import { KickAvatar } from "@components/avatar/KickAvatar";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { TaskAvatarLabel } from "./TaskAvatarLabel";
import { type TaskListTaskRow, toReadOnlyTaskCell } from "./taskRowCells";

const TaskCreatedBy = ({ task }: { task: TaskListTaskRow }) =>
    task.createdBy ? (
        <TaskAvatarLabel
            avatar={<UserAvatar user={task.createdBy} size="sm" aria-hidden />}
            label={task.createdBy.name}
        />
    ) : (
        <TaskAvatarLabel
            avatar={<KickAvatar size="sm" aria-hidden />}
            label="Kick"
        />
    );

/** The Created by column: the creator, or Kick for tasks Kick created. */
export const TaskCreatedByCell = toReadOnlyTaskCell(TaskCreatedBy);
